import React from 'react';

export default function OpenOsV2EmailModal({ v }) {
  if (!v || !v.emailModalOpen) return null;
  if (v.emailSentOk) {
    return (
      <div className="oosv2-email-modal-overlay" onClick={v.closeEmailModal}>
        <div className="oosv2-email-modal oosv2-email-modal--ok" onClick={(e) => e.stopPropagation()}>
          <div className="oosv2-email-modal-check" aria-hidden="true">✓</div>
          <div className="oosv2-email-modal-ok-title">E-mail enviado</div>
          <div className="oosv2-email-modal-ok-sub">Enviado para os destinatários informados.</div>
        </div>
      </div>
    );
  }
  return (
    <div className="oosv2-email-modal-overlay" onClick={v.emailSending ? undefined : v.closeEmailModal}>
      <div className="oosv2-email-modal" onClick={(e) => e.stopPropagation()}>
        <div className="oosv2-email-modal-head">
          <div className="oosv2-email-modal-title">Enviar email</div>
          <button type="button" className="oosv2-email-modal-x" onClick={v.closeEmailModal} aria-label="Fechar" disabled={!!v.emailSending}>×</button>
        </div>
        <div className="oosv2-email-field oosv2-email-modal-field">
          <div className="oosv2-email-chips">
            {(v.emailModalChips || []).map((em, i) => (
              <span key={i} className="oosv2-email-chip">
                <span className="oosv2-email-chip-text">{em.addr}</span>
                <button type="button" className="oosv2-email-chip-x" onClick={em.remove} aria-label="Remover e-mail" disabled={!!v.emailSending}>×</button>
              </span>
            ))}
            <input
              type="text"
              className="oosv2-email-input"
              value={v.emailModalDraft}
              onChange={v.setEmailModalDraft}
              onKeyDown={v.onEmailModalKey}
              onBlur={v.onEmailModalBlur}
              placeholder="email@exemplo.com"
              disabled={!!v.emailSending}
            />
          </div>
        </div>
        {v.emailSendError ? <div className="oosv2-email-modal-error">{v.emailSendError}</div> : null}
        <button
          type="button"
          className="oosv2-email-modal-send"
          onClick={v.sendEmailModal}
          disabled={!!v.emailSending || !(v.emailModalChips || []).length}
        >
          {v.emailSending ? 'Enviando…' : 'Enviar'}
        </button>
      </div>
    </div>
  );
}
